define([], function () {
    function config($stateProvider) {
        $stateProvider
            .state("app.welcome", {
                url: "/",
                controller: "DashboardCtrl",
                templateUrl: './app/modules/dashboard/dashboard.html',
                // Reuse userInfo resolved by app; project data loads after the
                // view mounts so the dashboard skeleton can render immediately.
            })
            .state('app.not-verified', {
                url: "/not-verified",
                controller: "NotVerifiedCtrl",
                templateUrl: './app/modules/dashboard/not-verified/not-verified.html',
                access: {restricted: false},
                resolve: {
                    notVerifiedRedirect: ['UserService', '$state', function (UserService, $state) {
                        return UserService.limits(true)
                            .then(function (res) {
                                if (res && res.data && res.data.isActive) {
                                    $state.go('app.welcome');
                                }
                            })
                            .catch(function (err) {
                                console.log(err);
                            });
                    }]
                }
            });
    }

    config.$inject = ['$stateProvider'];
    return config;
});
